export default function DateTimeFilter(value, format = 'YYYY-MM-DD HH:mm:ss') {
    if (value) {
        return moment(value).format(format);
    }
}
